import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import javascript from "../assets/img/javascript.png";
import firebase from "../assets/img/firebase.png";
import html from "../assets/img/html.png";
import react from "../assets/img/react.png";
import css from "../assets/img/css.png";
import typescript from "../assets/img/typescript.png";
import gitlab from "../assets/img/gitlab.png";
import bootstrap from "../assets/img/bootstrap.png";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={javascript} alt="Image" />
                  <h5>JavaScript</h5>
                </div>
                <div className="item">
                  <img src={react} alt="Image" />
                  <h5>React JS / React Native</h5>
                </div>
                <div className="item">
                  <img src={typescript} alt="Image" />
                  <h5>TypeScript</h5>
                </div>
                <div className="item">
                  <img src={firebase} alt="Image" />
                  <h5>Firebase</h5>
                </div>
                <div className="item">
                  <img src={gitlab} alt="Image" />
                  <h5>Gitlab</h5>
                </div>
                <div className="item">
                  <img src={css} alt="Image" />
                  <h5>Css</h5>
                </div>
                <div className="item">
                  <img src={html} alt="Image" />
                  <h5>Html</h5>
                </div>

                <div className="item">
                  <img src={bootstrap} alt="Image" />
                  <h5>Bootstrap</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
